import React, { Component } from "react";
import AudioWorkSpeedRender from "./children/AudioWorkSpeedRender";
import sentGAEvent from "@/ga";
import "@/assets/audioCutSpeedVolume.less";

class AudioWorkSpeedFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSpeedChange = value => {
    let speedValue = [];
    let speed = 1;
    if (value.indexOf(1) === -1) {
      if (this.props.audioCutSpeedVolumeObj.speedValue.indexOf(1) === 0) {
        speedValue[0] = value[0];
        speedValue[1] = 1;
        speed = value[0];
      } else {
        speedValue[0] = 1;
        speedValue[1] = value[1];
        speed = value[1];
      }
    } else {
      if (value[0] < 1) {
        speedValue[0] = value[0];
        speedValue[1] = 1;
        speed = value[0];
      } else if (value[1] > 1) {
        speedValue[0] = 1;
        speedValue[1] = value[1];
        speed = value[1];
      } else {
        speedValue = [1, 1];
      }
    }

    const audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    audioCutSpeedVolumeObj.speed = speed;
    audioCutSpeedVolumeObj.speedValue = speedValue;
    this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
    this.props.audioCutSpeedVolumeObj.wavesurfer.setPlaybackRate(speed);
  };

  componentDidMount() {
    sentGAEvent({
      category: "audio_speed_page",
      action: "audio_speed_functionpage_display",
    });
  }

  render() {
    return (
      <AudioWorkSpeedRender
        handleSpeedChange={this.handleSpeedChange}
        tooglePlay={() => {
          if (!this.props.playing) {
            sentGAEvent({
              category: "audio_speed_action",
              action: "audio_speed_play_click",
            });
          }
          this.props.tooglePlay();
        }}
        speedValue={this.props.audioCutSpeedVolumeObj.speedValue}
        speed={this.props.audioCutSpeedVolumeObj.speed}
        playing={this.props.playing}
      />
    );
  }
}

export default AudioWorkSpeedFunction;
